var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{attrs:{"fields":_vm.table.fields,"items":_vm.items,"empty-text":_vm.$t('GERAL.NENHUM_REGISTRO'),"head-variant":"light","stacked":"md","responsive":"","show-empty":"","striped":"","hover":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }